import { render, staticRenderFns } from "./ReassignTasksModal.vue?vue&type=template&id=734e2240&scoped=true&"
import script from "./ReassignTasksModal.vue?vue&type=script&lang=js&"
export * from "./ReassignTasksModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "734e2240",
  null
  
)

export default component.exports